// components/automacao/tema.js — cores da página Automação e das três abas
// (out/26).
//
// A página sempre usou a paleta CLARA do chat, valor por valor, copiada em
// cada arquivo (Automacao.js, AutomacaoMessages.js, AutomacaoIA.js). Agora
// os três leem daqui, e cada token é `var(--ch-*)` (pages/ChatPage.css): o
// tema escuro vira uma troca de atributo no <html>, como no chat, na Agenda,
// nos Formulários e no CRM — nenhum `sx` muda. O que o chat não tem (teal,
// sombra, prévia do WhatsApp) mora em `automacao.css` com o prefixo `--au-`.
//
// Cor nova nesta tela entra como token aqui, nunca como hex no `sx`: hex
// solto não segue o escuro.
import { createTheme } from '@mui/material';
import '../../pages/ChatPage.css';
import './automacao.css';

export const C = {
  bg: 'var(--ch-bg)', surf: 'var(--ch-surf)', card: 'var(--ch-card)', inset: 'var(--ch-inset)',
  bdr: 'var(--ch-bdr)', bdr2: 'var(--ch-bdr2)',
  text: 'var(--ch-text)', text2: 'var(--ch-text2)', text3: 'var(--au-text3)',
  green: 'var(--ch-green)', greenD: 'var(--ch-green-d)', greenBg: 'var(--ch-green-bg)', greenB: 'var(--ch-green-b)',
  greenGlow: 'var(--ch-green-glow)', greenHover: 'var(--ch-green-hover)',
  amber: 'var(--ch-amber)', amberD: 'var(--ch-amber-d)', amberBg: 'var(--ch-amber-bg)', amberB: 'var(--ch-amber-b)',
  red: 'var(--ch-red)', redD: 'var(--ch-red-d)', redBg: 'var(--ch-red-bg)', redB: 'var(--ch-red-b)',
  redHover: 'var(--au-red-hover)',
  blue: 'var(--ch-blue)', blueD: 'var(--ch-blue-d)', blueBg: 'var(--ch-blue-bg)', blueB: 'var(--ch-blue-b)',
  purple: 'var(--ch-purple)', purpBg: 'var(--ch-purple-bg)', purpB: 'var(--ch-purple-b)',
  teal: 'var(--au-teal)', tealBg: 'var(--au-teal-bg)', tealB: 'var(--au-teal-b)',
  sombra: 'var(--au-sombra)', sombraAviso: 'var(--au-sombra-aviso)',
  sobreCor: 'var(--au-sobre-cor)',
  // Prévia do WhatsApp (aba Mensagens personalizadas).
  waBg: 'var(--au-wa-wall)', waDot: 'var(--au-wa-dot)', waBubble: 'var(--au-wa-bolha)',
  waSombra: 'var(--au-wa-sombra)', waInk: 'var(--au-wa-ink)', waInk2: 'var(--au-wa-ink2)',
  waVazio: 'var(--au-wa-vazio)', waMidia: 'var(--au-wa-midia)', waMidiaInk: 'var(--au-wa-midia-ink)',
  waDoc: 'var(--au-wa-doc)', waDocInk: 'var(--au-wa-doc-ink)',
};

// Diálogos, menus, campos, alertas e tooltips do MUI calculam hover e
// transparência a partir da cor, então precisam de valor concreto (os
// mesmos do `--ch-*` escuro), não de `var()` — mesmo motivo do `temaMui` do
// CRM. No claro a página continua com o tema padrão do MUI, como sempre foi.
export const temaMuiClaro = createTheme();
export const temaMuiEscuro = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#00d67c', contrastText: '#060d14' },
    error: { main: '#f87171' },
    warning: { main: '#f59e0b' },
    success: { main: '#00d67c' },
    info: { main: '#38bdf8' },
    background: { default: '#070b13', paper: '#0a0f1a' },
    text: { primary: '#e8edf5', secondary: '#8090a4', disabled: '#3e4d60' },
    divider: 'rgba(255, 255, 255, 0.07)',
  },
  components: {
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiDialog: { styleOverrides: { paper: { border: '1px solid rgba(255, 255, 255, 0.13)' } } },
    MuiMenu: { styleOverrides: { paper: { border: '1px solid rgba(255, 255, 255, 0.13)' } } },
  },
});
